import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { fieldsToOmit } from 'providers/tanstack-query/utils'

import type { Schema } from 'features/inventory/domain/forms/RichPlacementsForm/sections/KWordsForm/schema'
import type { UpdateDomainKWordsMutationVariables } from 'gql/graphql'
import type { Ability } from 'providers/casl'

type From = Schema
type To = Omit<UpdateDomainKWordsMutationVariables['input'], 'domainId'>

export const toDTO = (from: From, ability: Ability): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      availability,
      customVariableName,
      customVariableTriggerEnabled,
      customVariableValue,
      enabled,
      kwordsSiteId,
      matchType,
      overrideWorkspaceDefaults,
      path,
      pathTriggerEnabled,
    }: From): To => {
      const constantFields: Omit<
        To,
        'availability' | 'kwordsSiteId' | 'overrideWorkspaceDefaultsEnabled'
      > = {
        customVariableTriggerEnabled,
        ...(customVariableTriggerEnabled ? { customVariableName, customVariableValue } : {}),
        enabled,
        pathTriggerEnabled,
        ...(pathTriggerEnabled ? { matchType, path } : {}),
      }

      const variableFields: Pick<
        To,
        'availability' | 'kwordsSiteId' | 'overrideWorkspaceDefaultsEnabled'
      > = {
        availability,
        overrideWorkspaceDefaultsEnabled: overrideWorkspaceDefaults,
        ...(overrideWorkspaceDefaults ? { kwordsSiteId } : {}),
      }

      return {
        ...constantFields,
        ...omit(
          variableFields,
          fieldsToOmit<To>({
            availability: ability.cannot(
              'update',
              'DomainRichPlacementsFeature-kWordsEmployeeSettings',
            ),
            kwordsSiteId: ability.cannot(
              'update',
              'DomainRichPlacementsFeature-kWordsEmployeeSettings',
            ),
            overrideWorkspaceDefaultsEnabled: ability.cannot(
              'update',
              'DomainRichPlacementsFeature-kWordsEmployeeSettings',
            ),
          }),
        ),
      }
    },
  )
